export default __webpack_public_path__ + "1bdcf267f2c1ccb42b6ec792901742fe.svg";